import { supabase } from '@/lib/supabase';

export const getIndexingStats = async () => {
  const { data, error } = await supabase
    .from('search_indexing_stats')
    .select('*')
    .maybeSingle();
    
  if (error) throw error;
  return data;
};

export const getQueueItems = async (limit = 50) => {
  const { data, error } = await supabase
    .from('search_indexing_queue')
    .select(`
      *,
      papers:paper_id (
        id,
        title
      )
    `)
    .order('created_at', { ascending: false })
    .limit(limit);
    
  if (error) throw error;
  return data;
};

export const getRecentLogs = async (limit = 50) => {
  const { data, error } = await supabase
    .from('search_indexing_log')
    .select(`
      *,
      papers:paper_id (
        id,
        title
      )
    `)
    .order('created_at', { ascending: false })
    .limit(limit);
    
  if (error) throw error;
  return data;
};

export const getSuccessRateByEngine = async (days = 7) => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - days);
  
  const { data, error } = await supabase
    .from('search_indexing_log')
    .select('google_status, bing_status')
    .gte('created_at', startDate.toISOString());
    
  if (error) throw error;
  
  // Calculate success rates
  const googleSuccess = data?.filter(l => l.google_status === 'success').length || 0;
  const bingSuccess = data?.filter(l => l.bing_status === 'success').length || 0;
  const total = data?.length || 1;
  
  return {
    google: Math.round((googleSuccess / total) * 100),
    bing: Math.round((bingSuccess / total) * 100),
    total
  };
};

export const getDailyIndexingVolume = async (days = 7) => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - days);
  
  const { data, error } = await supabase
    .from('search_indexing_log')
    .select('created_at, status')
    .gte('created_at', startDate.toISOString())
    .order('created_at', { ascending: true });
    
  if (error) throw error;
  
  // Group by date
  const dailyData: Record<string, { success: number; partial: number; failed: number }> = {};
  
  data?.forEach(log => {
    const date = new Date(log.created_at).toISOString().split('T')[0];
    if (!dailyData[date]) {
      dailyData[date] = { success: 0, partial: 0, failed: 0 };
    }
    
    if (log.status === 'success') dailyData[date].success++;
    else if (log.status === 'partial') dailyData[date].partial++;
    else if (log.status === 'failed') dailyData[date].failed++;
  });
  
  return Object.entries(dailyData).map(([date, counts]) => ({
    date,
    ...counts
  }));
};
